<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div class="top-menu-bar nav-bar">
    <div class="hamburger-menu" *ngIf="isMobileWidth && !isUnAuthenticatedRoute" (click)="toggleHamburgerMenu()"><i class="fa fa-bars fa-2x"></i></div>
    <div class="logo-container">
        <div class="logo" (click)="onLogoClick()">
            <img src="../../../assets/smrtscape_logo.png"/>
        </div>
        <div class="whats-new"><a href="https://www.smrt-logic.com/en/whats_new" target="_blank">What's New!</a></div>
    </div>

    <div *ngIf="!isMobileWidth" class="menu-item weather-menu-item">
        <app-weather></app-weather>
    </div>

    <div *ngIf="!isMobileWidth && !isUnAuthenticatedRoute" class="right-sub-menu">
        <ul class="rogue">
            <li class="top-menu-home-icon"><img class="icon" src="../../../assets/home-icon.png" (click)="onGoHome()"/></li>

            <li id="top-menu-name" class="menu-item dropdown" appDropdown>
                <a class="dropdown-toggle pointer-cursor" role="button">
                    <span class="red">Hello </span>
                    <span>{{user?.FName | Limit: 10}}</span>
                    <span class="caret"></span></a>
                <ul class="dropdown-menu">
                    <li routerLink="/dashboard/locations/user/edit">
                        <a class="pointer-cursor">
                            <i class="fa fa-user"></i><span class="sign-out">Profile</span>
                        </a>
                    </li>
                    <li routerLink="/dashboard/locations/user/preferences">
                        <a class="pointer-cursor">
                            <i class="fa fa-cog"></i><span class="preferences">Notification Preferences</span>
                        </a>
                    </li>
                    <li (click)="onSignOut()">
                        <a class="pointer-cursor">
                            <i class="fa fa-power-off"></i><span class="sign-out">Sign Out</span>
                        </a>
                    </li>

                </ul>
            </li>

            <!-- Temporary: Test menu for exposing otherwise hidden functionality -->
            <li *ngIf="false" class="menu-item dropdown" appDropdown>
                <a class="dropdown-toggle pointer-cursor" role="button">Test<span class="caret"></span></a>
                <ul class="dropdown-menu">
                    <li><a class="pointer-cursor" (click)="onSendAlert()">Send Alert</a></li>
                    <li><a class="pointer-cursor" (click)="onClearAlert()">Clear Alert</a></li>
                </ul>
            </li>

            <li class="menu-item dropdown" appDropdown *ngIf="user?.IsToroAdministrator">
                <a class="dropdown-toggle pointer-cursor" role="button">Admin<span class="caret"></span></a>
                <ul class="dropdown-menu">
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/info">Info</a></li>
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/firmware">Firmware</a></li>
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/messages">Messages</a></li>
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/accounts">Accounts</a></li>
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/devices">Devices</a></li>
                    <li><a class="pointer-cursor" routerLink="/dashboard/admin/users">Users</a></li>
                </ul>
            </li>

            <li *ngIf="!isUnAuthenticatedRoute" class="menu-item menu-item-mail-center" (click)="toggleMailCenter()">
                <i class="fa fa-lg fa-bell"></i>
                <div *ngIf="mailCenterManager.numberOfUnreadMessages !== 0 && !isMailCenterLoadingMessages" class="top-menu-number-of-notifications">
                    {{mailCenterManager.numberOfUnreadMessages}}
                </div>
            </li>
        </ul>
    </div>
</div>
